export function mainYaml() {
  return `id: "**TemplateId**"
name: |-
  **TemplateName**
databaseName: |-
  **TemplateDatabaseName**
description: |-
  **TemplateDescription**
author:
  id: "**AuthorId**"
  firstName: "**AuthorFirstName**"
  lastName: "**AuthorLastName**"
  email: "**AuthorEmail**"

variables: {}
connectors:
  - id: "**SelfConnectorId**"
    providerId: "**SelfConnectorProviderId**"
    name: HexaSync
    description:
    options:
      - key: IS_SELF_CONNECTOR
        value: true
        name: Is Self Connector
        description: This connector is for internal usage of HexaSync's Worker.
        displayType: BOOLEAN
pullers: []
pushers: []
objects: []
validations: {}
dependencies: []
tables: []
schemas: []
webhooks: []
reports: []
transformations: {}
objectAssociations: {}

externals:
  - type: local
    path: ./variables.yaml
`;
}
